import React, { useEffect, useState } from "react";
import { Table, Tooltip } from "antd";
import { TbRestore } from "react-icons/tb";
import { MdDelete } from "react-icons/md";
import dayjs from "dayjs";
import ModalPopup from "../Common/Modal/Modal";
import BinDelete from "./BinDelete";
import BinRestore from "./BinRestore";
import { capitalizeFirstLetter ,capitalizeEachWord} from "../Common/Captilization";
import {
  TiArrowUnsorted,
  TiArrowSortedUp,
  TiArrowSortedDown,
} from "react-icons/ti";
import ReactPaginate from "react-js-pagination";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
  faAngleDoubleLeft,
  faAngleDoubleRight,
} from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";

export default function OffersDeals({
  selectedTab,
}) {
  const [tbsId, setTbsId] = useState();
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [restoreModalOpen, SetRestoreModalOpen] = useState(false);
  const [rowName, SetRowName] = useState();
   const [sortOrderOfferTitle, setSortOrderOfferTitle] = useState(null);
    const [sortedData, setSortedData] = useState();
    const [sortOrderOfferCode, setSortOrderOfferCode] = useState(null);
    const [sortOrderOfferDate, setSortOrderOfferDate] = useState(null);
    const crud=sessionStorage.getItem("crud_permission")
       const getBin = useSelector((state) => state.crm.bin_data);
     const [activePage, setActivePage] = useState(1);
     const itemsPerPage = selectedTab === 3 ? 5 : selectedTab === 4 ? 5 : 10;
   
     const indexOfLastItem = activePage * itemsPerPage;
     const indexOfFirstItem = indexOfLastItem - itemsPerPage;
     const currentItems = sortedData?.length > 0
      ? sortedData.slice(indexOfFirstItem, indexOfLastItem): getBin.slice(indexOfFirstItem, indexOfLastItem)
     // Handle page change
     const handlePageChange = (pageNumber) => {
       setActivePage(pageNumber);
     };

  const closeDeleteModal = () => {
    setDeleteModalOpen(false);
    SetRestoreModalOpen(false);
  };

  const handleOfferTitleSort = () => {
  let sorted =[...getBin];

  if (sortOrderOfferTitle === "ascend") {
    sorted.sort((a, b) => {
      const nameA = a.deleted_data.offer_name || "";
      const nameB = b.deleted_data.offer_name || "";
      return nameB.localeCompare(nameA);
    });
    setSortOrderOfferTitle("descend");
  } else if (sortOrderOfferTitle === "descend") {
    sorted =[...getBin]
    setSortOrderOfferTitle(null);
  } else {
    sorted.sort((a, b) => {
      const nameA = a.deleted_data.offer_name || "";
      const nameB = b.deleted_data.offer_name || "";
      return nameA.localeCompare(nameB);
    });
    setSortOrderOfferTitle("ascend");
  }

  setSortedData(sorted);
};

  const handleOfferCodeSort = () => {
  let sorted =[...getBin]
  if (sortOrderOfferCode === "ascend") {
    sorted.sort((a, b) => {
      const codeA = a.deleted_data?.code || "";
      const codeB = b.deleted_data?.code || "";
      return codeB.localeCompare(codeA);
    });
    setSortOrderOfferCode("descend");
  } else if (sortOrderOfferCode === "descend") {
    sorted =[...getBin]
    setSortOrderOfferCode(null);
  } else {
    sorted.sort((a, b) => {
      const codeA = a.deleted_data?.code || "";
      const codeB = b.deleted_data?.code || "";
      return codeA.localeCompare(codeB);
    });
    setSortOrderOfferCode("ascend");
  }

  setSortedData(sorted);
};

  const handleOfferDateSort = () => {
    let sorted = [...getBin]
    if (sortOrderOfferDate === "ascend") {
      sorted.sort(
        (a, b) =>
          dayjs(b.deleted_date).valueOf() - dayjs(a.deleted_date).valueOf()
      );
      setSortOrderOfferDate("descend");
    } else if (sortOrderOfferDate === "descend") {
      sorted = [...getBin]
      setSortOrderOfferDate(null);
    } else {
      sorted.sort(
        (a, b) =>
          dayjs(a.deleted_date).valueOf() - dayjs(b.deleted_date).valueOf()
      );
      setSortOrderOfferDate("ascend");
    }
    setSortedData(sorted);
  };

  const columns = [
    {
      title: (
        <div className="flex font-bold  justify-center text-[1.1vw]">S.No</div>
      ),
      width: "5vw",
      render: (row, rowdta, index) => {
        const pageNo = (activePage - 1) * itemsPerPage + index + 1;
        return (
          <div className="">
            <h1 className="pl-[.5vw] text-[#1F4B7F] text-[1vw] text-center">
              {pageNo}
            </h1>
          </div>
        );
      },
    },
    {
      title: (
        <h1 className="text-[1.1vw] font-bold  flex items-center justify-center  ">
          Name
          <button onClick={handleOfferTitleSort} className="">
                                {sortOrderOfferTitle === "ascend" ? (
                                  <Tooltip
                                    placement="top"
                                    title="Ascending"
                                    className="cursor-pointer"
                                    color="white"
                                    overlayInnerStyle={{
                                      color: "#1F487C",
                                    }}
                                  >
                                    <TiArrowSortedUp />
                                  </Tooltip>
                                ) : sortOrderOfferTitle === "descend" ? (
                                  <Tooltip
                                    placement="top"
                                    title="Descending"
                                    className="cursor-pointer"
                                    color="white"
                                    overlayInnerStyle={{
                                      color: "#1F487C",
                                    }}
                                  >
                                    <TiArrowSortedDown />
                                  </Tooltip>
                                ) : sortOrderOfferTitle === null ? (
                                  <Tooltip
                                    placement="top"
                                    title="Unsorted"
                                    className="cursor-pointer"
                                    color="white"
                                    overlayInnerStyle={{
                                      color: "#1F487C",
                                    }}
                                  >
                                    <TiArrowUnsorted />
                                  </Tooltip>
                                ) : (
                                  <Tooltip
                                    placement="top"
                                    title="Ascending"
                                    className="cursor-pointer"
                                    color="white"
                                    overlayInnerStyle={{
                                      color: "#1F487C",
                                    }}
                                  >
                                    <TiArrowSortedUp />
                                  </Tooltip>
                                )}
                              </button>
        </h1>
      ),
      render: (row, rowdta, index) => {
        return (
          <div className="flex items-center pl-[1vw] font-bold  text-[#1F4B7F] ">
            {row?.deleted_data.offer_name?.length > 15 ? (
              <Tooltip
                placement="bottom"
                title={row?.deleted_data.offer_name}
                className="cursor-pointer"
                color="#1F487C"
              >
                <p className="text-[1vw]">
                  {" "}
                  <span>
                    {`${row?.deleted_data?.offer_name?.charAt(0) === row?.deleted_data?.offer_name?.charAt(0).toLowerCase()
                      ? capitalizeEachWord(row?.deleted_data?.offer_name.slice(0, 15))
                      : row?.deleted_data?.offer_name.slice(0, 15)}...`}
                  </span>
                </p>
              </Tooltip>
            ) : (
              <h1 className="text-[1vw] font-bold">
                <span>
                  {console.log(row.deleted_data.offer_name, "offer name")}
                  {row?.deleted_data?.offer_name === null ? "-" : row?.deleted_data?.offer_name?.charAt(0) === row?.deleted_data?.offer_name?.charAt(0).toLowerCase()
                    ? capitalizeEachWord(row?.deleted_data?.offer_name?.length > 15 ? (row?.deleted_data?.offer_name.slice(0, 15)) : (row?.deleted_data?.offer_name))
                    : row?.deleted_data?.offer_name?.length > 15 ? (row?.deleted_data?.offer_name.slice(0, 15)) : (row?.deleted_data?.offer_name)}
                </span>
              </h1>
            )}
          </div>
        );
      },
      width: "15vw",
    },
    {
      title: (
        <h1 className="text-[1.1vw] font-bold justify-center  flex items-center ">
          Code
          <button onClick={handleOfferCodeSort} className="">
                                {sortOrderOfferCode === "ascend" ? (
                                  <Tooltip
                                    placement="top"
                                    title="Ascending"
                                    className="cursor-pointer"
                                    color="white"
                                    overlayInnerStyle={{
                                      color: "#1F487C",
                                    }}
                                  >
                                    <TiArrowSortedUp />
                                  </Tooltip>
                                ) : sortOrderOfferCode === "descend" ? (
                                  <Tooltip
                                    placement="top"
                                    title="Descending"
                                    className="cursor-pointer"
                                    color="white"
                                    overlayInnerStyle={{
                                      color: "#1F487C",
                                    }}
                                  >
                                    <TiArrowSortedDown />
                                  </Tooltip>
                                ) : sortOrderOfferCode === null ? (
                                  <Tooltip
                                    placement="top"
                                    title="Unsorted"
                                    className="cursor-pointer"
                                    color="white"
                                    overlayInnerStyle={{
                                      color: "#1F487C",
                                    }}
                                  >
                                    <TiArrowUnsorted />
                                  </Tooltip>
                                ) : (
                                  <Tooltip
                                    placement="top"
                                    title="Ascending"
                                    className="cursor-pointer"
                                    color="white"
                                    overlayInnerStyle={{
                                      color: "#1F487C",
                                    }}
                                  >
                                    <TiArrowSortedUp />
                                  </Tooltip>
                                )}
                              </button>
        </h1>
      ),
      width: "18vw",
      render: (row) => {
        return (
          // <div className="flex items-center justify-center ">
          //   {row?.deleted_data.code?.length > 15 ? (
          //     <Tooltip
          //       placement="right"
          //       title={row?.deleted_data.code}
          //       className="cursor-pointer"
          //       color="#1F487C"
          //     >
          //       <button className="border-dashed text-[1vw] bg-[#1F4B7F] border-white border-[0.2vw] rounded-[0.5vw] text-white w-[14vw] ">
          //         {`${row?.deleted_data.code?.slice(0, 15)}...`}{" "}
          //       </button>
          //     </Tooltip>
          //   ) : (
          //     <button className="border-dashed text-[1vw] bg-[#1F4B7F] border-white border-[0.2vw] rounded-[0.5vw] text-white w-[14vw] ">
          //       {row?.deleted_data.code?.slice(0, 15)}
          //     </button>
          //   )}
          // </div>
          <div className="flex items-center justify-center">
            {row?.deleted_data?.code?.length > 10 ? (
              <Tooltip
                placement="right"
                title={row?.deleted_data?.code}
                className="cursor-pointer"
                color="white"
                overlayInnerStyle={{
                  color: "#1F487C",
                }}
              >
                <div className="border-[0.1vw] border-[#1F487C] rounded-[0.5vw]">
                  <div className="border-dashed text-[1vw] bg-[#1F4B7F] border-white border-[0.2vw] rounded-[0.5vw] text-white w-[10vw] flex items-center justify-center">
                    {`${row?.deleted_data?.code?.slice(0, 7)}...`}{" "}
                  </div>
                </div>
              </Tooltip>
            ) : (
              <div className="border-[0.1vw] border-[#1F487C] rounded-[0.5vw]">
                <div className="border-dashed text-[1.1vw] bg-[#1F4B7F] border-white border-[0.2vw] rounded-[0.5vw] text-white w-[10vw] flex items-center justify-center ">
                  {row?.deleted_data?.code?.slice(0, 7)}
                </div>
              </div>
            )}
            {/* <button className="border-dashed text-[1.1vw] bg-[#1F4B7F] border-white border-[0.2vw] rounded-[0.5vw] text-white w-[14vw] ">
                        {row.code}
                      </button> */}
          </div>
        );
      },
    },

    {
      title: (
        <div className="flex font-bold justify-center text-[1.1vw]">
          Duration
        </div>
      ),
      width: "15vw",
      render: (row) => {
        return (
          <div className="flex justify-center text-[#1F4B7F] ">
            <p className="text-[1vw]">{`${dayjs(
              row?.deleted_data.start_date
            ).format("MMM DD")} - ${dayjs(row?.deleted_data.expiry_date).format(
              "MMM DD"
            )}`}</p>
          </div>
        );
      },
    },
    {
      title: (
        <div className="flex  justify-center font-bold text-[1.1vw]">Usage</div>
      ),
      width: "8vw",
      render: (row) => {
        return (
          <div className="flex items-center pl-[1.2vw] text-[#1F4B7F] ">
            <p className="text-[1vw]">{row.deleted_data.usage}</p>
          </div>
        );
      },
    },
    {
      title: (
        <h1 className="text-[1.1vw] font-bold justify-center  flex items-center">
          Deleted Date
          <button onClick={handleOfferDateSort} className="">
                                {sortOrderOfferDate === "ascend" ? (
                                  <Tooltip
                                    placement="top"
                                    title="Ascending"
                                    className="cursor-pointer"
                                    color="white"
                                    overlayInnerStyle={{
                                      color: "#1F487C",
                                    }}
                                  >
                                    <TiArrowSortedUp />
                                  </Tooltip>
                                ) : sortOrderOfferDate === "descend" ? (
                                  <Tooltip
                                    placement="top"
                                    title="Descending"
                                    className="cursor-pointer"
                                    color="white"
                                    overlayInnerStyle={{
                                      color: "#1F487C",
                                    }}
                                  >
                                    <TiArrowSortedDown />
                                  </Tooltip>
                                ) : sortOrderOfferDate === null ? (
                                  <Tooltip
                                    placement="top"
                                    title="Unsorted"
                                    className="cursor-pointer"
                                    color="white"
                                    overlayInnerStyle={{
                                      color: "#1F487C",
                                    }}
                                  >
                                    <TiArrowUnsorted />
                                  </Tooltip>
                                ) : (
                                  <Tooltip
                                    placement="top"
                                    title="Ascending"
                                    className="cursor-pointer"
                                    color="white"
                                    overlayInnerStyle={{
                                      color: "#1F487C",
                                    }}
                                  >
                                    <TiArrowSortedUp />
                                  </Tooltip>
                                )}
                              </button>
        </h1>
      ),
      width: "12vw",
      render: (row) => {
        return (
          <div className="flex items-center pl-[3vw]  text-[#1F4B7F] ">
            <p className="text-[1vw]">{`${dayjs(row?.deleted_date).format(
              "DD MMM, YY"
            )}`}</p>
          </div>
        );
      },
    },
    {
      title: (
        <div className="flex justify-center font-bold text-[1.1vw]">Status</div>
      ),
      width: "10vw",
      render: (row) => {
        return (
          <div className="flex justify-center  text-[#1F4B7F] ">
            <button
              className={`${row.deleted_data.status_id === 0
                ? "bg-[#646262]"
                : row.deleted_data.status_id === 1
                  ? "bg-[#FF9900]"
                  : row.deleted_data.status_id === 2
                    ? "bg-[#34AE2b]"
                    : row.deleted_data.status_id === 3
                      ? "bg-[#2A99FF]"
                      : "bg-[#FD3434]"
                } h-[1.8vw] shadow-md shadow-[black] font-extrabold text-[1vw] cursor-not-allowed text-white w-[7vw] rounded-[0.5vw]`}
            >
              {row.deleted_data.status}
            </button>
          </div>
        );
      },
    },
    {
      title: (
        <div className="flex justify-center font-bold text-[1.1vw]">
          Actions
        </div>
      ),
      width: "10vw",
      render: (row) => {
        return (
          <div className="flex justify-center">
            <div className="flex gap-[0.7vw] items-center">
              <span
                 className={`${crud?.includes("view")||crud?.includes("create")||crud?.includes("delete")?"cursor-not-allowed":"cursor-pointer"}`}
                onClick={() => {
                    if(!crud?.includes("view") && !crud?.includes("delete") && !crud?.includes("create")){
                  SetRestoreModalOpen(true);
                  setTbsId(row?.tbs_recycle_id);
                  SetRowName(row?.deleted_data.offer_name);
                  console.log(selectedTab, "heifhjbdfh");
                }}}
              >
                <TbRestore size={"1.3vw"} color="#1F4B7F" />
              </span>
              <span>
                <MdDelete
                  size={"1.3vw"}
                  color="#1F4B7F"
                 className={`${crud?.includes("view")||crud?.includes("create")||crud?.includes("update")?"cursor-not-allowed":"cursor-pointer"}`}
                  onClick={() => {
                    if(!crud?.includes("view") && !crud?.includes("update") && !crud?.includes("create")){
                    setDeleteModalOpen(true);
                    setTbsId(row?.tbs_recycle_id);
                    SetRowName(row?.deleted_data.offer_name);
                  }}}
                />
              </span>
            </div>
          </div>
        );
      },
    },
  ];

  console.log(selectedTab, "tabtabtba");

  return (
    <>
      <div className="h-[72vh] w-full">
        <Table
          dataSource={currentItems}
          columns={columns}
          pagination={false}
          className="custom-table"
        />
      </div>
            <div>
        {getBin?.length > 10 ? (
            <div className="w-full h-[8vh] flex justify-between items-center ">
              <div className="text-[#1f4b7f] flex text-[1.1vw] gap-[0.5vw]">
                <span>Showing</span>
                <span className="font-bold">
                  {currentItems && currentItems?.length > 0 ? (
                    <div>
                      {indexOfFirstItem + 1} -{" "}
                      {indexOfFirstItem + currentItems?.length}
                    </div>
                  ) : (
                    "0"
                  )}
                </span>
                <span>from</span>
                <span className="font-bold">
                  {getBin?.length > 0 ? getBin?.length : 0}
                </span>
                <span>data</span>
              </div>
              <div>
                <ReactPaginate
                  activePage={activePage}
                  itemsCountPerPage={itemsPerPage}
                  totalItemsCount={getBin?.length}
                  pageRangeDisplayed={3}
                  onChange={handlePageChange}
                  itemClass="page-item"
                  linkClass="page-link"
                  activeClass="active"
                  prevPageText={
                    <FontAwesomeIcon icon={faChevronLeft} size="1vw" />
                  }
                  nextPageText={
                    <FontAwesomeIcon icon={faChevronRight} size="1vw" />
                  }
                  firstPageText={
                    <FontAwesomeIcon icon={faAngleDoubleLeft} size="1vw" />
                  }
                  lastPageText={
                    <FontAwesomeIcon icon={faAngleDoubleRight} size="1vw" />
                  }
                />
              </div>
            </div>
          ) : (
            ""
          )}
      </div>
      <ModalPopup
        show={deleteModalOpen}
        onClose={closeDeleteModal}
        height="21vw"
        width="30vw"
        closeicon={false}
      >
        <BinDelete
          setDeleteModalOpen={setDeleteModalOpen}
          deleteid={tbsId}
          // title={`want to delete ( ${rowName} ) offer Permenantly`}
          title={
            <>
              Want to delete{" "}
              <span style={{ fontWeight: "bold" }}>{capitalizeEachWord(rowName)}</span> offer
              permenantly ?
            </>
          }
          id={tbsId}
          tab={selectedTab}
        />
      </ModalPopup>

      <ModalPopup
        show={restoreModalOpen}
        onClose={closeDeleteModal}
        height="21vw"
        width="30vw"
        closeicon={false}
      >
        <BinRestore
          SetRestoreModalOpen={SetRestoreModalOpen}
          // title={`want to restore ( ${rowName} ) offer`}
          title={
            <>
              Want to restore{" "}
              <span style={{ fontWeight: "bold" }}>{capitalizeEachWord(rowName)}</span> offer ?
            </>
          }
          id={tbsId}
          tab={selectedTab}
        />
      </ModalPopup>
    </>
  );
}
